import { cn } from '@/lib/utils';

interface JacKeyIconProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function JacKeyIcon({ className, size = 'md' }: JacKeyIconProps) {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  return (
    <div className={cn('relative', sizeClasses[size], className)}>
      {/* Heart shape with jade green */}
      <svg
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        {/* Heart outline */}
        <path
          d="M24 42C24 42 6 30 6 18C6 12 10.5 7 16.5 7C20.5 7 23.5 9.5 24 11C24.5 9.5 27.5 7 31.5 7C37.5 7 42 12 42 18C42 30 24 42 24 42Z"
          stroke="hsl(160, 35%, 55%)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="hsl(160, 35%, 55%)"
          fillOpacity="0.15"
        />
        
        {/* Key icon in center */}
        <g transform="translate(16, 16)">
          {/* Key head (circle) */}
          <circle
            cx="8"
            cy="6"
            r="4"
            stroke="hsl(160, 35%, 45%)"
            strokeWidth="2"
            fill="none"
          />
          {/* Key body */}
          <line
            x1="8"
            y1="10"
            x2="8"
            y2="18"
            stroke="hsl(160, 35%, 45%)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          {/* Key teeth */}
          <line
            x1="8"
            y1="14"
            x2="11"
            y2="14"
            stroke="hsl(160, 35%, 45%)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="8"
            y1="17"
            x2="10"
            y2="17"
            stroke="hsl(160, 35%, 45%)"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
      </svg>
    </div>
  );
}
